/* Modo "colapsar" del bloque de badges de sabor (blocks/flavor-badges.liquid).
   Cuando los badges no caben en el ancho disponible, los sobrantes se
   sustituyen por barras de color. Un solo archivo para todas las
   instancias (antes cada tarjeta emitía su propio <script> inline). */
(function () {
  'use strict';

  if (customElements.get('flavor-badges')) return;

  class FlavorBadges extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-collapse')) return;
      this._fit = this._fit || this.fit.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._fit, { once: true });
      } else {
        this._fit();
      }

      if (window.ResizeObserver && !this._observer) {
        this._observer = new ResizeObserver(this._fit);
        this._observer.observe(this);
        if (this.parentElement) this._observer.observe(this.parentElement);
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    budget() {
      var p = this.parentElement;
      if (!p) return this.clientWidth;
      var cs = getComputedStyle(p);
      return p.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
    }

    fits(b) {
      return this.getBoundingClientRect().width <= b + 0.5;
    }

    fit() {
      var items = this.querySelectorAll('.fb-item');
      if (!items.length) return;

      items.forEach(function (it) {
        it.querySelector('.fb-full').style.display = '';
        it.querySelector('.fb-mini').style.display = 'none';
      });

      var b = this.budget();
      if (this.fits(b)) return;

      var firstFull = items[0].querySelector('.fb-full');
      var h = firstFull.getBoundingClientRect().height;
      var miniW = Math.max(6, Math.round(h / 2));

      for (var i = items.length - 1; i >= 1; i--) {
        items[i].querySelector('.fb-full').style.display = 'none';
        var mini = items[i].querySelector('.fb-mini');
        mini.style.display = 'inline-block';
        mini.style.width = miniW + 'px';
        mini.style.height = h + 'px';
        if (this.fits(b)) return;
      }
    }
  }

  customElements.define('flavor-badges', FlavorBadges);
})();
